<template>
  <div v-if="rootStore.isShowFooter">
    <!-- 약관 링크 -->
    <div class="footer-link">
      <button @click="clickCompanyIntroduce()">회사소개</button>
      <button @click="clickPersonalInfo()">개인정보처리방침</button>
      <button @click="clickTerms()">이용약관</button>
    </div>

    <div class="footer-info">
      <!-- 영업시간 -->
      <div class="footer-operation-info">
        <div class="cs-center"><span>고객센터</span><strong><a href='tel:1688-8211'>1688-8211</a></strong></div>
        <div class="hours">
          <p class="hours-txt01">
            상담시간 <span>AM 8:00 ~ PM 5:00</span>
            <button @click="clickCustomerService()">1:1 문의하기</button>
          </p>
          <p class="hours-txt02">토요일, 일요일, 공휴일 휴무<br>드시모네몰 고객센터는 점심시간에도 계속 됩니다.</p>
        </div>
        <ul class="footer-banner">
          <li class="logo1"><img src="@/assets/images/footer_logo1.svg" alt="드시모네"></li>
          <li class="logo3"><img src="@/assets/images/footer_logo3.svg" alt="O2 Booster"></li>
          <li class="logo2" v-if="false"><img src="@/assets/images/footer_lab.png" alt="또박케어LAB"></li>
          <li class="logo1"><img src="@/assets/images/footer_kim.svg" alt="김석진LAB"></li>
        </ul>
      </div>

      <!-- 회사정보 -->
      <div class="footer-copyright">
        <address>
          <span>주식회사 헥토헬스케어  대표 : 이경민, 김석진</span><br>
          <span>주소 : 서울특별시 강남구 테헤란로 223, 10층</span> <span>(역삼동, 큰길타워빌딩)</span><br>
          <span>건강기능식품 판매업 : 제2013-0050453호</span><br>
          <span>통신판매업 : 제2015-서울강남-03602호</span><br>
          <span>사업자등록번호 : 209-81-58898 <button class="" @click="clickBizInfoConfirm()">[사업자정보확인]</button></span><br>
          <span>개인정보보호책임자 : 유민수</span>
        </address>

        <p>
          <span>[KOR]</span> 이메일 : admin_hc@hecto.co.kr <span>신규 거래 문의 : <a href='tel:1811-0171'>1811-0171</a></span><br>
          <span>[ENG, CHN]</span> <span>이메일 : h_ob@hecto.co.kr</span><br>
          <span>Copyright HECTO Healthcare co., Ltd. All right reserved.</span>
        </p>

        <ul class="footer-banner">
          <li class="escrow"><img src="@/assets/images/img_escrow.png" alt="에스크로"></li>
          <li class="ftc"><img src="@/assets/images/img_ftc.svg" alt="공정거래위원회"></li>
        </ul>
      </div>
    </div>
  </div>
  
</template>

<script setup lang="ts">
const rootStore = useRootStore();
const authStore = useAuthStore();

// 회사소개
const clickCompanyIntroduce = (): void => {
  const config = useRuntimeConfig();
  const url = config.public.VITE_COMPANY_INTRODUCE_URL;
  
  if (isMobileApp() && isAndroid()) {
    window.android.openBrowser(url);
  } else {
    window.open(url, '_blank');
  }
};

// 개인정보처리방침
const clickPersonalInfo = (): void => {
  navigateTo('/privacy');
};

// 이용약관
const clickTerms = (): void => {
  navigateTo('/agreement');
};

// 1:1 문의하기
const clickCustomerService = async (): Promise<void> => {
  if (authStore.isLogin) {
    navigateTo('/mypage/qna');
  } else {
    showLoginPage('/mypage/qna');
  }
};

// 사업자정보확인
const clickBizInfoConfirm = (): void => {
  window.open('http://www.ftc.go.kr/info/bizinfo/communicationViewPopup.jsp?wrkr_no=2098158898','communicationViewPopup','width=750,height=800,scrollbars=1');
};
</script>

<style scoped>
  p{
    margin-bottom:0;
  }

  /* 약관 링크 */
  .footer-link{
    display:flex;
    align-items: center;
    padding:2.8rem 4rem;
    border-top: 1px solid #e3e3e3;
    background-color: #f9f9f9;
  }
  .footer-link button{
    font-size:var(--hecto-font-22);
    color:var(--hecto-gray-800);
    line-height:1;
  }
  .footer-link button+button{
    margin-left:2rem;
    padding-left:2rem;
    border-left:1px solid #cbcbcb;
  }
  .footer-link .logout{
    margin-left:auto;
    padding-left:0;
    border-left:0;
  }

  .footer-info{
    padding: 3rem;
    border-top: 1px solid #e3e3e3;
  }

  /* 영업시간 */
  .footer-operation-info{
    padding: 0 1rem;
    font-size:var(--hecto-font-22);
    color:var(--hecto-gray-800);
    word-break:keep-all;
  }
  .footer-operation-info .cs-center span{
    display:block;
    font-size:var(--hecto-font-24);
    color: #000;
  }
  .footer-operation-info .cs-center strong{
    display:block;
    font-family:'Roboto';
    font-size:var(--hecto-font-40);
    line-height:1;
  }
  .footer-operation-info .cs-center a{
    color:#000;
    text-decoration: none;
  }

  .footer-operation-info .hours{
    margin-top:1rem;
    letter-spacing: -0.05em;
  }
  .hours-txt01{
    display: flex;
    align-items: center;
    color:#333;
    font-size:var(--hecto-font-26);
  }
  .hours-txt01 span{
    display:inline-block;
    margin-left:1rem;
    padding-left:1rem;
    line-height:1;
    border-left:1px solid #666;
  }
  .hours-txt01 button{
    margin-left:2rem;
    width: 15rem;
    height: 5rem;
    line-height: 1;
    font-size:var(--hecto-font-24);
    letter-spacing: -0.1em;
    color: #5e5e5e;
    border:0.2rem solid #e2e2e2;
    border-radius:0.8rem;
    background-color: var(--hecto-white);
  }
  .hours-txt02{
    color:var(--hecto-gray-800);
    font-size:var(--hecto-font-24);
  }
  .hours-txt03{
    margin-top:0.8rem;
    color:var(--hecto-gray-800);
  }


  /* 회사정보 */
  .footer-copyright{
    margin-top: 4rem;
    padding: 4rem 1rem 0;
    border-top: 2px dotted #989898;
    font-size:var(--hecto-font-22);
    font-weight:400;
    letter-spacing: -0.05em;
    color:var(--hecto-gray-800);
  }
  .footer-copyright a,
  .footer-copyright button{
    font-weight: bold;
    text-decoration: none;
    color:var(--hecto-gray-800);
  }
  .footer-copyright span{
    display:inline-block;
  }

  address{
    margin-bottom:3rem;
  }

  .footer-banner{
    list-style: none;
    padding: 0;
    margin:3rem 0 0;
    display: flex;
    align-items: center;
  }
  .footer-operation-info .footer-banner{
    justify-content: space-between;
  }
  .footer-banner li + li{
    margin-left: 2.5rem;
  }
  .footer-banner img{
    width:100%;
  }
  .logo1{
    width:13.3rem;
  }
  .logo2{
    width:17rem;
  }
  .logo3{
    width:17rem;
  }
  .ftc{
    width:23.3rem;
  }
  .escrow{
    width: 6.2rem;
  }
</style>